import { menu } from './menu';
import { router } from './router';

export const Firemni = {
	menu,
	router,
};
